import React from 'react';

const ActionButton = ({
  onClick = () => {},
  disabled = false,
  className = '',
  id,
  type = 'button',
  children
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={className}
      id={id}
      type={type}
    >
      {children}
    </button>
  );
};

export default ActionButton;